import { MatchItem } from "../../app/models/matchItem";

interface MatchCardProps {
  item: MatchItem
  handleSelectedCards: (values: MatchItem) => void;
  toggled: boolean;
  stopflip: boolean;
  color?: string;
  coverImage?: string;
}

const MatchCard: React.FC<MatchCardProps> = ({
  item,
  handleSelectedCards,
  toggled,
  stopflip,
  color,
  coverImage,
}) => {
  const backStyle: React.CSSProperties = {
    // background color fallback to the CSS default if none provided
    backgroundColor: color || undefined,
    // show centered image as “sticker” without stretching
    backgroundImage: coverImage ? `url(${coverImage})` : undefined,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
  };

  return (
    <div className="match-item">
      <div className={toggled ? "toggled" : ""}>
        <img className="match-face" src={item.img} alt={item.name} />
        <div
          className="match-back"
          style={backStyle}
          onClick={() => !stopflip && handleSelectedCards(item)}
          aria-label={item.name}
          role="button"
        >
          {" "}
        </div>
      </div>
    </div>
  )
}

export default MatchCard;